import React, { useCallback } from 'react'
import { PlayerStates } from 'data/VideoPlayer'
import PlayerWrapper from 'components/set/InteractionPlayer/PlayerWrapper/PlayerWrapper'
import VideoPlayer from 'components/set/InteractionPlayer/VideoPlayer/VideoPlayer'
import { getVideoUrl } from 'utils/mux'
import { Show, VideoOnDemand } from 'data/Show'
import { Unpopulated } from 'data/Populated'
import { Pass } from 'data/Pass'
import { useDispatch } from 'react-redux'
import { preShowPreRollEnded } from 'redux/slices/liveShow'

interface PreShowPreRollProps {
    hypeVideoVOD: VideoOnDemand
    videoStartTime?: number
    show: Show
    passList: Unpopulated<Pass, 'show'>[]
}

const PreShowPreRoll: React.FC<PreShowPreRollProps> = ({ show, hypeVideoVOD, videoStartTime, passList }) => {
    const dispatch = useDispatch()

    const onPreRollEnded = useCallback(() => {
        dispatch(preShowPreRollEnded())
    }, [dispatch])

    return (
        <PlayerWrapper stateId={PlayerStates.PRE_SHOW_W_PRE_ROLL}>
            <VideoPlayer
                type="vod"
                videoTitle={`preroll-${show.title}`}
                show={show}
                src={getVideoUrl(hypeVideoVOD.playbackId)}
                disablePauseControls
                videoEndedCallback={onPreRollEnded}
                videoStartTime={videoStartTime}
                disableChromecast
                passList={passList}
            />
        </PlayerWrapper>
    )
}

export default React.memo(PreShowPreRoll)
